import { Component, Vue } from "vue-facing-decorator";
import { isMobile } from "../helpers/is_mobile";

@Component
export default class Error extends Vue {
    //#region Computed Properties

    get isMobileActive() {
      return isMobile.any() || this.$store.state.isIFrameLoaded;
    }

    get errorMessage() {
      return this.$store.state.errorMessage || "";
    }

    //#endregion
}
